var _circle, _circle2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultsFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 124.999,
    r: 108.333,
    fill: "#FECDD3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.417,
    cy: 125.417,
    r: 95.4167,
    fill: "#FDA4AF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_418_10988)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 124.999,
    r: 83.3333,
    fill: "#FB7185"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.6667 119.582C81.6667 122.579 84.0873 124.999 87.0834 124.999C90.0795 124.999 92.5001 122.579 92.5001 119.582C92.5001 110.61 99.7787 103.331 108.75 103.331H135.833V108.748C135.833 110.932 137.154 112.912 139.185 113.759C141.216 114.605 143.535 114.131 145.093 112.591L155.926 101.756C158.042 99.6404 158.042 96.2039 155.926 94.0878L145.093 83.2535C143.535 81.6961 141.216 81.239 139.185 82.0855C137.154 82.9319 135.833 84.8956 135.833 87.0794V92.4965H108.75C93.7865 92.4965 81.6667 104.617 81.6667 119.582ZM168.333 130.416C168.333 127.42 165.913 124.999 162.917 124.999C159.921 124.999 157.5 127.42 157.5 130.416C157.5 139.389 150.221 146.668 141.25 146.668H114.167V141.251C114.167 139.067 112.846 137.086 110.815 136.24C108.784 135.393 106.465 135.867 104.908 137.408L94.0743 148.242C91.9584 150.358 91.9584 153.795 94.0743 155.911L104.908 166.745C106.465 168.303 108.784 168.76 110.815 167.913C112.846 167.067 114.167 165.103 114.167 162.902V157.502H141.25C156.214 157.502 168.333 145.381 168.333 130.416Z",
    fill: "#FECDD3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_418_10988",
    x: 41.6667,
    y: 41.666,
    width: 166.667,
    height: 170.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_418_10988"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsFail);
export default __webpack_public_path__ + "static/media/results-fail.b899222852743d62996f2013611fae20.svg";
export { ForwardRef as ReactComponent };